import { useTheme } from "@mui/material"
import { ReactElement } from "react"

import { TDevicesToInstall } from "../../../services/middleware/mappers/dnoInterface/dnoApplicationsMapper"
import VerticalKeyValueList from "../../dataDisplay/verticalKeyValueList"
import LctAvatar from "../../pills/lct/lctAvatar"
import { LCT_METADATA_DISPATCHER } from "../../pills/lct/lctMetadataDispatcher"
import { AppCard, AppCardHeader, AppCardContent } from "../../surfaces/appCard"

interface IDemandGeneralNotDatabaseDeviceProps {
    deviceReference: string
    deviceType: string
    details: TDevicesToInstall
}

/**
 * Card for displaying details about an proposed demand device
 * at a property. Designed for use on the single application summary page.
 * This component has been designed to be schema version agnostic. It picks
 * of a number of core fields and ingests the rest via the generic `details`.
 * object. This is for demand devices not listed on ENA databases.
 *
 * This component caters for two device classes:
 * - demandGeneralNotDatabase
 * - demandHpNotDatabase
 *
 */
const DemandGeneralNotDatabaseDevice = ({
    deviceReference,
    deviceType,
    details,
}: IDemandGeneralNotDatabaseDeviceProps): ReactElement => {
    const theme = useTheme()
    return (
        <AppCard
            sx={{ backgroundColor: theme.palette.background.contentBackground }}
        >
            <AppCardHeader
                title={deviceReference}
                subheader={LCT_METADATA_DISPATCHER[deviceType]?.label}
                avatar={<LctAvatar lcts={[deviceType]} />}
            />
            <AppCardContent>
                <VerticalKeyValueList kwargs={details} />
            </AppCardContent>
        </AppCard>
    )
}

export default DemandGeneralNotDatabaseDevice
